import React, { useEffect, useCallback } from 'react'
import usePersistedFilters from '../../hooks/usePersistedFilters'
import PageHeader from '../../shared/PageHeader'
import { HiOutlineShieldExclamation } from 'react-icons/hi'
import { useTranslation } from 'react-i18next'
import PharmacyClaimGenerationTable from '../../components/his/claimgeneration/PharmacyClaimGenrationTable'
import useFetchData from '../../hooks/UseFetchData'
import moment from 'moment'

function PharmacyClaimGeneration() {
  const { t } = useTranslation()
  const { executeFetch, data, loading } = useFetchData()
  const { filters: payload, setFilters: setPayload, appliedFilters, applyFilters, resetFilters, onPageChange } = usePersistedFilters(
    'pharmacy_claim_generation',
    {
      page: 1,
      perPage: 10,
      start_date: moment().subtract(1, 'month').format('YYYY-MM-DD'),
      end_date: moment().format('YYYY-MM-DD'),
      payer_id: '',
      patient_filenumber: '',
      patient_document_id: '',
      patient_phone: ''
    }
  )
  const fetchData = useCallback((payloadData = appliedFilters) => {
    executeFetch('POST', 'v3/visit/list/pharmacy', payloadData)
  }, [executeFetch, appliedFilters])

  useEffect(() => {
    fetchData()
  }, [appliedFilters])

  return (
    <div className='main-page-container !overflow-y-auto scrollbar'>
      <PageHeader
        title={t('Pharmacy Claim Generation')}
        iconSize={20}
        Icon={HiOutlineShieldExclamation}
      ></PageHeader>
      <div>
        <PharmacyClaimGenerationTable
          data={data}
          loading={loading}
          payload={payload}
          setPayload={setPayload}
          applyFilters={applyFilters}
          resetFilters={resetFilters}
          onPageChange={onPageChange}
          fetchData={fetchData}
        />
      </div>
    </div>
  )
}

export default PharmacyClaimGeneration
